import React from 'react'
import { isNil, isEmpty } from 'lodash'

import { FormField } from '@/components/forms/FormField'

// Only works for nested select at the moment
export const NestedSelectReadOnly = ({ label, field: { name, value }, required, ...props }) => {
  const noneSelected = isNil(value) || isEmpty(value?.selected)

  return (
    <FormField className={props.className} data-testid={`${name}-read-only`}>
      {label && <label htmlFor={name}>{label} (Read-Only)</label>}
      {noneSelected ? (
        <div>None selected</div>
      ) : (
        <div>
          <div className="muted-text">{value.includes ? 'Includes:' : 'Does not include:'}</div>
          {value.selected.map((entry) => {
            const entryArr = entry.split('-')
            entryArr.shift()
            const entryString = entryArr.join('')

            return <div>{entryString}</div>
          })}
        </div>
      )}
    </FormField>
  )
}
